import Loading from '@/common/components/Loading';
import Table from '@/common/components/Table';
import { Header } from '../consultantEmail/styles/ConsultantEmailPage.styles';
import { Wrapper } from '../consultantSalary/ConsultantSalary.styled';
import NewCommentModal from './components/NewCommentModal';
import { TABLE_HEADERS } from './constants/table';
import { getTableRows } from './helpers/getTableRows';
import useConsultantFollowUpShipments from './hooks/useConsultantFollowUpShipments';

const ConsultantFollowUpShipments = () => {
	const hook = useConsultantFollowUpShipments();

	return (
		<>
			{hook.isLoading && <Loading />}
			<Wrapper>
				<Header className={`fade__in__animation`}>
					Shipments to Follow Up
				</Header>

				{hook.displayedRows && (
					<Table
						className='styled-table fade__in__animation'
						raws={getTableRows(hook.displayedRows, hook.openModal)}
						headers={TABLE_HEADERS}
					/>
				)}
			</Wrapper>

			{hook.modalOrderId && (
				<NewCommentModal
					closeFunction={hook.closeModal}
					onSubmit={hook.submitModal}
				/>
			)}
		</>
	);
};

export default ConsultantFollowUpShipments;
